import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { AppUpdateService } from '../../services/app-update.service';

// TODO(design): botões '.update-btn-cancel/.update-btn-primary' têm estilo bespoke
// (flex:1, paddings/box-shadow próprios) acoplado ao layout deste modal; migrar para
// one-button mudaria o visual. Manter nativo até alinhar tokens com o design-system.
@Component({
  selector: 'app-update-modal',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './update-modal.component.html',
  styleUrls: ['./update-modal.component.css']
})
export class UpdateModalComponent {
  constructor(
    private dialogRef: MatDialogRef<UpdateModalComponent>,
    private appUpdateService: AppUpdateService
  ) {}

  dismiss(): void {
    this.dialogRef.close();
    this.appUpdateService.dismissUpdate();
  }

  update(): void {
    this.dialogRef.close();
    this.appUpdateService.performUpdate();
  }
}
